import { LawsuitItem } from "@components/pages/lawsuit";
import { fetchLawsuitList } from "@services/lawsuit";
import React from "react";
import { useInfiniteQuery } from "react-query";
import { Button } from "nectar-ui";
import { EmptyStateLawsuits } from "@components/svgs";
import { CustomHeading, HeadingContainer, Subtitle, TitleContainer } from "@pages/style";
import { ListCard, NormalText } from "@components/styles/dataDisplay";
import { EmptyState } from "@components/EmptyState";
import LawsuitListItemSkeleton from "@pages/skeletons/LawsuitsListItemSkeleton";
import { MoreButtonContainer } from "./style";

const LawsuitListPage = () => {
  const { data, isLoading, isSuccess, hasNextPage, fetchNextPage } = useInfiniteQuery({
    queryKey: ["fetchLawsuitList"],
    queryFn: fetchLawsuitList,
    getNextPageParam: (lastPage) => {
      return lastPage.cursor === "-1" ? undefined : lastPage.cursor;
    },
  });
  const handleFetchMore = () => {
    fetchNextPage();
  };

  if (isLoading && !isSuccess) return <LawsuitListItemSkeleton />;

  const lawsuitTotalCount = data.pages[0].total;
  const lawsuitCurrentCount = data.pages.reduce((acc, page) => {
    return acc + page.lawsuits.length;
  }, 0);

  return (
    <div>
      <HeadingContainer>
        <TitleContainer>
          <CustomHeading noMargin>Processos e casos</CustomHeading>
          <Subtitle color="gray" size="lg" noMargin>
            Encontre todos os seus processos e casos e escolha um deles para ver mais detalhes.
          </Subtitle>
        </TitleContainer>
      </HeadingContainer>
      {lawsuitCurrentCount > 0 && (
        <>
          <NormalText margin="xs" color="gray">
            {`Mostrando ${lawsuitCurrentCount} de ${lawsuitTotalCount} processos e casos`}
          </NormalText>
          <ListCard border>
            {isSuccess &&
              data &&
              data.pages.map((lawsuitPage, pageIndex) => {
                const { lawsuits } = lawsuitPage;
                const hasLawsuits = lawsuits.length > 0;
                return (
                  <React.Fragment key={pageIndex}>
                    {hasLawsuits && (
                      <>
                        {lawsuits.map((lawsuit) => {
                          return <LawsuitItem key={`${lawsuit.id}`} lawsuit={lawsuit} />;
                        })}
                      </>
                    )}
                  </React.Fragment>
                );
              })}
          </ListCard>
        </>
      )}
      {lawsuitCurrentCount === 0 && (
        <EmptyState icon={<EmptyStateLawsuits />} title="Nenhum processo ou caso disponível">
          Entre em contato com o seu advogado.
        </EmptyState>
      )}
      {hasNextPage && (
        <MoreButtonContainer>
          <Button onClick={handleFetchMore} color="primary" reverse>
            carregar mais processos e casos
          </Button>
        </MoreButtonContainer>
      )}
    </div>
  );
};

export default LawsuitListPage;
